import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileFormatPipe } from './mobile-format.pipe';

@NgModule({
  declarations: [MobileFormatPipe],
  imports: [CommonModule],
  exports: [MobileFormatPipe],
})
export class MobileFormatModule {}
